import React, { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Avail, call } from "./common";

function MapEditor({ v, items, onSaved }) {
  const [rows, setRows] = useState(v.stock_mappings.map((m) => ({ ...m })));
  const set = (i, k, val) => setRows(rows.map((r, j) => (j === i ? { ...r, [k]: val } : r)));
  const save = async () => { const d = await call(() => api.put(`/pim/variants/${v.id}/stock-mappings`, { mappings: rows.map((r) => ({ stock_item_id: r.stock_item_id, qty: Number(r.qty) })) }), "Stock mapping saved"); if (d) onSaved(d); };
  return (
    <div className="space-y-1" data-testid={`pim-map-${v.sku}`}>
      {rows.map((r, i) => (
        <div key={i} className="flex gap-1 items-center">
          <select className="text-xs border rounded px-1 py-0.5 max-w-[220px]" value={r.stock_item_id} onChange={(e) => set(i, "stock_item_id", e.target.value)} data-testid={`pim-map-item-${v.sku}-${i}`}>
            {items.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>
          <input type="number" min="1" className="w-14 text-xs border rounded px-1 py-0.5" value={r.qty} onChange={(e) => set(i, "qty", e.target.value)} data-testid={`pim-map-qty-${v.sku}-${i}`} />
          <button className="text-xs text-rose-600" onClick={() => setRows(rows.filter((_, j) => j !== i))} data-testid={`pim-map-remove-${v.sku}-${i}`}>remove</button>
        </div>))}
      <div className="flex gap-2">
        <button className="text-xs text-indigo-700" onClick={() => setRows([...rows, { stock_item_id: items[0]?.id, qty: 1 }])} data-testid={`pim-map-add-${v.sku}`}>+ component</button>
        <Button size="sm" variant="outline" className="h-6 text-xs" onClick={save} data-testid={`pim-map-save-${v.sku}`}>Save mapping</Button>
      </div>
    </div>
  );
}

export function VariantsStock({ d, items, onChange }) {
  const name = (id) => items.find((s) => s.id === id)?.name || id;
  const editable = d.status === "draft";
  return (
    <div className="overflow-x-auto"><table className="w-full min-w-[560px] text-xs" data-testid="pim-variants">
      <thead><tr className="text-left text-slate-500"><th className="py-1">SKU</th><th>Attributes</th><th>Price inc VAT</th><th>Stock mapping (explicit)</th><th>Availability</th></tr></thead>
      <tbody>{d.variants.map((v) => (
        <tr key={v.id} className="border-t align-top" data-testid={`pim-variant-${v.sku}`}>
          <td className="py-1 font-medium">{v.sku}<div className="text-slate-400">GTIN {v.gtin || "—"}</div></td>
          <td>{Object.entries(v.attributes).map(([k, x]) => `${k}: ${x}`).join(", ") || "—"}</td>
          <td>£{v.price_inc_vat.toFixed(2)}</td>
          <td>{editable && ["physical", "bundle"].includes(d.product_type) ? <MapEditor v={v} items={items} onSaved={onChange} /> :
            v.stock_mappings.length ? v.stock_mappings.map((m) => <div key={m.stock_item_id}>{m.qty} × {name(m.stock_item_id)}</div>) : <span className="text-slate-400">none ({d.product_type})</span>}
            {v.shared_stock_items.length > 0 && <div className="text-amber-700">Shares stock with another variant (explicitly mapped)</div>}</td>
          <td><Avail a={v.availability} /></td>
        </tr>))}
      </tbody>
    </table></div>
  );
}
